import "../index.css"

export default function BoxContent(props) {
  return <div className="box-content">{props.children}</div>
}
